/**
 * @fileoverview
 * Loader Service - Manages global loader overlay state with messages
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly loadingSignal = signal<boolean>(false);
  private readonly messageSignal = signal<string>('Processing...');

  // Public readonly signals
  readonly loading = this.loadingSignal.asReadonly();
  readonly message = this.messageSignal.asReadonly();

  /**
   * Show loader with optional message
   */
  show(message: string = 'Processing...'): void {
    this.messageSignal.set(message);
    this.loadingSignal.set(true);
  }

  /**
   * Hide loader
   */
  hide(): void {
    this.loadingSignal.set(false);
  }

  /**
   * Reset loader state
   */
  reset(): void {
    this.loadingSignal.set(false);
    this.messageSignal.set('Processing...');
  }
}
